import React from 'react';
import { Box, Typography } from '@mui/material';
import SingleLineText from './ui/SingleLineText';
import Button from './ui/FitButton';
import { readAppLanguage } from '../i18n';

export default function PermissionNotice({ icon, title, description, actionLabel, onAction }) {
    const international = readAppLanguage() !== 'ko';
    const Title = international ? Typography : SingleLineText;
    return (
        <Box role="status" sx={{
            display: international ? 'grid' : 'flex', alignItems: 'center', gap: 1.25,
            ...(international && { gridTemplateColumns: '28px minmax(0, 1fr)' }),
            minHeight: 72, px: '11px', py: '9px', mb: 1.5, bgcolor: '#fff',
            border: '2px solid #e8ad19', borderRadius: '12px',
        }}>
            <Box sx={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: 28, height: 28, flexShrink: 0, borderRadius: '50%', bgcolor: '#ffedb3', color: '#8a6500',
                '& svg': { fontSize: 18 },
            }}>{icon}</Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Title sx={{ fontSize: '0.94rem', fontWeight: 700, color: '#1a1a1a', lineHeight: 1.4, overflowWrap: 'anywhere' }}>
                    {title}
                </Title>
                <Typography sx={{
                    mt: 0.5, fontSize: '0.82rem', color: '#6b7280', lineHeight: 1.5,
                    wordBreak: 'keep-all', overflowWrap: 'anywhere',
                }}>{description}</Typography>
            </Box>
            <Button onClick={onAction} sx={{
                flex: '0 0 80px', width: 80, minWidth: 80, height: 44, minHeight: 44, px: 1,
                borderRadius: '9px', border: '1px solid #e5e7eb', bgcolor: '#fff',
                color: '#374151', fontSize: '0.88rem', fontWeight: 700,
                ...(international && { gridColumn: 2, width: '100%', flex: 'initial' }),
                '&:hover': { bgcolor: '#f5f6f8' },
            }}>{actionLabel}</Button>
        </Box>
    );
}
